import { prop } from 'ramda'

import { EMPTY_ARRAY } from '~/src/Lib/Utils'
import InProgress from '~/src/UI/Icons/InProgress'

import { renderCommentStatus, renderPriorityStatus, renderProgressStatus } from '../utils'

export const formatTask = ({ annotation, entities }) => {
  const {
    assignees = EMPTY_ARRAY,
    title,
    description,
    category: categoryId,
    comments = EMPTY_ARRAY,
    priority
  } = annotation
  const { taskCategories } = entities

  const assigneesWorkingCount = assignees.filter(prop('lastStartTs')).length
  const status = []
  let category = null

  if (taskCategories) {
    const { [categoryId]: categoryEntity } = taskCategories
    category = categoryEntity.taskBehavior ? categoryEntity.name : null
  }

  if (priority) {
    status.push(renderPriorityStatus(priority))
  }

  if (assigneesWorkingCount) {
    status.push(renderProgressStatus(InProgress))
  }

  if (comments.length) {
    status.push(renderCommentStatus(comments))
  }

  return {
    title,
    status,
    body: description,
    category
  }
}
